import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { FieldType, IField, ISelectData } from '@sla-ng/ui-material';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ICostingLevel } from '../../models/costing-level.model';
import { CostingLevelTypeEnum } from '../../models/enum/costing-level-type.enum';
import { ICostingLevelLayout } from '../../models/layout/costing-level-layout.model';
import { SharedDataFacade } from '../facades/master-data/shared-data.facade';

@Injectable({
    providedIn: 'root',
})
export class CostingLevelLayoutService {

    constructor(protected mySharedDataFacade: SharedDataFacade) {
    }

    public getCostingLevelDialogLayout(): ICostingLevelLayout {

        const parentSelectData: ISelectData<ICostingLevel> = {
            displaySearch: true,
            labelKeys: [ 'name' ],
            valueKey: 'id',
            options: this.mySharedDataFacade.fetchCostingLevels().pipe(map(costingLevels => costingLevels.filter(cL => !cL.other))),
        };

        const typeOptions: { value: string, label: string }[] = [];

        for (const value of Object.values(CostingLevelTypeEnum)) {
            typeOptions.push({ value, label: `app.model.costing-level.costingLevelType.${value}.label` });
        }

        const dialogFields: IField[] = [
            { field: 'name', label: 'app.model.costing-level.name.label', type: FieldType.text, required: true },
            {
                field: 'parentCostingLevelId',
                label: 'app.model.costing-level.parentCostingLevelId.label',
                type: FieldType.select,
                validatorFn: [ this.disableTypeInputIfSubordinate() ],
                selectData: parentSelectData,
            },
            {
                field: 'costingLevelType',
                label: 'app.model.costing-level.costingLevelType.label',
                type: FieldType.select,
                validatorFn: [ this.disableParentInputIfTypSelected() ],
                selectData: {
                    valueKey: 'value',
                    labelKeys: [ 'label' ],
                    options: of(typeOptions),
                },
            },
        ];

        return {
            columns: [ 'name', 'actions' ],
            dialogFields,
        };
    }


    private disableTypeInputIfSubordinate(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors => {

            // if a subordinate CostingLevel is selected, clear and disable type-input; Else enable type-input
            if (control.value) {
                control.parent.get('costingLevelType').patchValue(null, { emitEvent: false });
                !control.parent.get('costingLevelType').disabled ? control.parent.get('costingLevelType').disable({ emitEvent: false }) : null;
            } else {
                !control.parent.get('costingLevelType').enabled ? control.parent.get('costingLevelType').enable({ emitEvent: false }) : null;
            }
            return null;
        };
    }

    private disableParentInputIfTypSelected(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors => {

            // if a subordinate CostingLevel is selected, clear and disable type-input; Else enable type-input
            if (control.value) {
                control.parent.get('parentCostingLevelId').patchValue(null, { emitEvent: false });
                !control.parent.get('parentCostingLevelId').disabled ? control.parent.get('parentCostingLevelId').disable({ emitEvent: false }) : null;
            } else {
                !control.parent.get('parentCostingLevelId').enabled ? control.parent.get('parentCostingLevelId').enable({ emitEvent: false }) : null;
            }
            return null;
        };
    }


}
